module.exports = __webpack_public_path__ + "static/media/happy-fill.78997307.svg";